import React from 'react';
import { Pagination } from 'antd';

const CommonPagination = ({ total, pageSize, currentPage, onPageChange, onPageSizeChange , showSizeChanger = true }) => {
  return (
    <div style={paginationStyle}>
    <Pagination
      current={currentPage}
      onChange={onPageChange}
      total={total}
      pageSize={pageSize}
      showSizeChanger={showSizeChanger}
      showQuickJumper
      onShowSizeChange={onPageSizeChange} 
      pageSizeOptions={['10', '20', '30', '40', '50']}  
      
    />
    </div>
  );
  
};

const paginationStyle = {
    display: 'flex',
    justifyContent: 'center',  // Centers horizontally
    alignItems: 'center',      // Centers vertically
  };

export default CommonPagination;